
// CWI CODE J
if ($(".custom_review .review_list").length) {
  $(".custom_review .review_list").each(function(index, review_grid) {
    let review_grid_Swiper = new Swiper(review_grid, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 32,
      navigation: {
        nextEl: $(review_grid).closest(".custom_review").find(".next_arrow")[0],
        prevEl: $(review_grid).closest(".custom_review").find(".prev_arrow")[0],
      },   
      pagination: {
        el: $(review_grid).closest(".custom_review").find(".review_dot")[0],
        clickable: true,
      },        
      breakpoints: {
        990: {
          slidesPerView: 3,
        },         
        750: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },        
      },      
    });
    // $(".featured_collection_tab").removeClass("hidden");
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const stickySection = document.querySelector('#shopify-section-template--26897414521137__1782222720c5a30e21.shopify-section');
  const scrollThreshold = 80; // Show after 80px scroll
  let isVisible = false;
  
  // Hide initially if not scrolled enough
  if (window.scrollY < scrollThreshold) {
    stickySection.classList.remove('visible');
    document.body.classList.remove('has-sticky-bar');
  }
  
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    if (currentScroll > scrollThreshold && !isVisible) {
      // Show the sticky bar
      stickySection.classList.add('visible');
      document.body.classList.add('has-sticky-bar');
      isVisible = true;
    } else if (currentScroll <= scrollThreshold && isVisible) {
      // Hide the sticky bar
      stickySection.classList.remove('visible');
      document.body.classList.remove('has-sticky-bar');
      isVisible = false;
    }
  }, { passive: true });
});